import type { ReactNode } from 'react';

interface HistoryMetadataItemProps {
  icon: ReactNode;
  label: string;
  value: string;
}

export function HistoryMetadataItem({ icon, label, value }: HistoryMetadataItemProps) {
  return (
    <div className="flex min-w-0 items-center gap-1.5">
      <span className="text-muted-foreground/70">{icon}</span>
      <span className="text-sm">
        <span className="text-muted-foreground">{label}: </span>
        <span className="text-foreground/75">{value}</span>
      </span>
    </div>
  );
}
